import {Store} from "@ngrx/store";
import {IAppState} from "../app-store/state/app.state";
import {Injectable} from "@angular/core";
import {LoadConfigurationForHost, SetConfigurationHost} from "../app-store/actions/configuration/configuration.actions";
import {Presenter} from "../../api/internal/presenter/presenter";
import {defaultConfiguration, IConfiguration, IConfigurationState} from "../app-store/state/configuration/configuration.state";

/**
 * Сервис управления конфигурациями приложения
 */

@Injectable({
  providedIn: 'root'
})
export class ConfigurationManager {
  private localhostConfiguration: IConfiguration = {...defaultConfiguration};
  public localHostReplaceHost ='';
  constructor(
    private _store: Store<IAppState>,
    public presenter: Presenter
  ) {
  }
  setLocalHostConfiguration(configuration:IConfiguration) {
    this.localhostConfiguration = JSON.parse(JSON.stringify(configuration));
  }
  getLocalhostConfiguration():IConfiguration {
    return JSON.parse(JSON.stringify(this.localhostConfiguration));
  }

  /**
   * Загрузить конфигурацияю для хоста
   * @param host - домен или ip для которого будет загружена конфигурация
   */
  loadConfigurationForHost(host?: string, protocol?: string, port?: string) {
    const newHost = host ? host : host;//this.window.location.hostname;
    this._store.dispatch(new LoadConfigurationForHost({host: newHost, protocol: protocol, port: port}));

  }

  /**
   * Получить полный URL для конкретного api
   * @param api
   */
  getApiUrl(api: string) {
    const configurationState: IConfigurationState = this.presenter.getConfigurationState();
    if (configurationState.isLoaded) {
      const url =
        `${configurationState.data.api.protocol}://${configurationState.data.api.host}:${configurationState.data.api.port}${configurationState.data.api.baseUrls[configurationState.data.api.apiUrls[api].apiVersion]}${configurationState.data.api.apiUrls[api].url}`;
      return url;
    } else {
      return '';
    }
  }

  setHost(host: string) {
    this._store.dispatch(new SetConfigurationHost({host: host}));
  }

  /**
   * Получить текущую тему
   */
  get theme(): string {
    const configurationState: IConfigurationState = this.presenter.getConfigurationState();
    return configurationState.isLoaded ? configurationState.data.theme : '';
  }

  get realm(): string {
    const configurationState: IConfigurationState = this.presenter.getConfigurationState();
    return configurationState.isLoaded ? configurationState.data.auth.realm : '';
  }

  get supportEmail(): string {
    return this.configuration.pagesConfig.login.supportEmail;
  }

  /**
   * Получить текущую конфигурацию
   */
  get configuration():IConfiguration {
    return this.presenter.getConfigurationState()? this.presenter.getConfigurationState().data : {...defaultConfiguration};
  }

  /**
   * Получить текущий домен
   */
  get domainUrl():string {
    return `${this.configuration.api.protocol}://${this.configuration.api.host}`;
  }
  /**
   * Получить текущий домен c портом
   */
  get domainUrlWithPort():string {
    return this.configuration.api.port?`${this.domainUrl}:${this.configuration.api.port}`:`${this.domainUrl}`;
  }
  /**
   * получить путь вместе с темой для иконок
   */
  get appLogoPath():string {
    return `img/app_icons/${this.configuration.theme}/`;
  }
  /**
   * получить путь вместе с темой для лого
   */
  get imgLogoPath():string{
    return `img/logo/${this.configuration.theme}/`;

  }
  /**
   * получить путь вместе с темой для иконок приложений
   */
  get moduleLogoPath():string {
    return `img/module_icons/${this.configuration.theme}/`;

  }

}
